module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/golf-a02c8d06a4a67990e9940a6fd552db60.svg";